/**
 * tarotCards — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const tarotCardsPack: ToilePack = {
    slug: 'tarot-cards',
    category: 'tarot',
    name: 'Tarot cards',
    tagline: tagline('cards', 'arcana', 'styles'),
    chips: chips('arcana', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'moon', label: 'The Moon', subject: 'a full moon between two towers, a dog, a wolf and a crayfish'},
        {key: 'lovers', label: 'The Lovers', subject: 'two figures beneath a winged presence, a mountain between them'},
        {key: 'fool', label: 'The Fool', subject: 'a traveler stepping off a cliff with a bundle and a white flower'},
    ],
    styles: [
        {key: 'woodcut', label: 'Woodcut', style: 'Marseille woodcut, thick hand-cut black outlines', palette: 'flat ochre, red and blue on aged paper', framing: 'upright card, title panel at the foot'},
        {key: 'nouveau', label: 'Art nouveau', style: 'sinuous whiplash linework, lilies and vines in the border', palette: 'muted sage green and gold', framing: 'upright card, title panel at the foot'},
        {key: 'gothic', label: 'Dark gothic', style: 'heavy black ink, a skull-and-thorn border', palette: 'deep crimson and bone white', framing: 'upright card, title panel at the foot'},
    ],
    directions: ['the Star instead', 'in deep blue and silver', 'a plainer, quieter border'],
}
